import angular from 'angular';
import CSMCommonWeb from 'csm-common-web';
import groupListDialogTemplate from '../../templates/GroupsListDialog.template.html';

export default angular
  .module('entitiesAdmin.dialogs.GroupsListDialog', [CSMCommonWeb])
  .service('GroupsListDialog', Service)
  .name;

/*******************************************************************************
 * Service: GroupsListDialog
 *
 * Generates the GroupsListReport for either a single group or all groups for an
 * organization.
 *******************************************************************************/
/* @ngInject */ function Service($uibModal) {
  /****************************************************************************
   * show */
  /**
   * Show the modal dialog for printing groups.
   *
   * @param  groupList    List of groups for the dataprovider
   * @param  forClubs     For Clubs List Flag. Sets the correct entity type and
   *                      label.
   *
   * @return              Promise that resolves when the modal dialog is closed.
   ****************************************************************************/
  this.show = function (groupList, forClubs) {
    return $uibModal.open({
      animation: true,
      backdrop: 'static',
      controller: GroupsListDialogController,
      resolve: {
        groupList: function () {
          return groupList;
        },
        forClubs: function () {
          return forClubs;
        }
      },
      size: 'md',
      template: groupListDialogTemplate
    }).result;
  };
}

/** Dialog Controller. */
/* @ngInject */
var GroupsListDialogController = function (
  $scope,
  SERVER,
  Session,
  forClubs,
  groupList
) {
  /***************************************************************************
   * Properties
   ***************************************************************************/
  /** All Groups Option */ var mAllGroups = {
    name: 'All ' + (forClubs ? 'Clubs' : 'Groups'),
    id: 0
  };
  /** List of Groups to print */ $scope.dpGroups = [];
  /** Dialog Title. */ $scope.dialogTitle = forClubs
    ? 'Print Clubs'
    : 'Print Groups';
  /** Current Group selection */ $scope.selectedGroup;
  /** Current Report type */ $scope.reportFormat;

  /***************************************************************************
   * generateList */
  /**
   * Print list in a new window.
   ***************************************************************************/
  $scope.generateList = function () {
    var pageURL =
      '/books/GroupsList.aspx?rt=' +
      $scope.reportFormat +
      '&et=' +
      (forClubs
        ? SERVER.BooksDBConstants.ET_CLUB
        : SERVER.BooksDBConstants.ET_GROUP
      ).toString() +
      '&gid=' +
      $scope.selectedGroup.id.toString() +
      '&ao=' +
      $scope.chkActiveOnly.toString();
    window.open(Session.getSessionURL(pageURL));
  };

  /***************************************************************************
   * init */
  /**
   * Set up the dataprovider based on the flags passed in to the dialog.
   * items.
   ***************************************************************************/
  function init() {
    /*-------------------------------------------------*/
    /* Set up the groups dataprovider with only the    */
    /* necessary properties and the all groups option. */
    /*-------------------------------------------------*/
    $scope.dpGroups = groupList.map(function (e) {
      return { id: e.id, name: e.name };
    });
    $scope.dpGroups.unshift(mAllGroups);

    /*--------------------------------------*/
    /* Preselect the default dialog values. */
    /*--------------------------------------*/
    $scope.selectedGroup = $scope.dpGroups[0];
    $scope.chkActiveOnly = true;
    $scope.reportFormat = 'PDF';
  }

  /*--------------------------*/
  /* Set up the modal dialog. */
  /*--------------------------*/
  init();
};
